{
  "en": {
    "company": {
      "actions": {
        "changeCompany": "Change company",
        "searchCompany": "Search company"
      },
      "attributes": {
        "address": "Address",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Language",
        "name": "Company name",
        "phone": "Phone",
        "subdomain": "Subdomain",
        "vat": "VAT"
      },
      "labels": {
        "company": "Company",
        "contact": "Contact",
        "contacts": "Contacts",
        "language": "This is the company's default language for your login page, customers and team members.",
        "or": "OR"
      },
      "validation": {
        "contactAlreadyExist": "Contact already exists. Please select from the dropdown.",
        "mustBeEmailAddress": "Valid email address required",
        "needName": "Name is required"
      }
    }
  }
}